

(function dateTimePickerModule() {

    angular.module('DateTimePicker', ['Popup', 'TimePicker', 'ui.bootstrap.dateparser', 'ui.bootstrap.datepicker']);

})();